import { useCurrentUser } from '~/common'

export const useCanViewPpp = (): boolean => {
  const { id, hasRole } = useCurrentUser()
  return Boolean(id) && hasRole('LABEL_REQUESTS')
}
